import { connect } from 'react-redux'
import React from 'react'
import { Link, withRouter } from 'react-router-dom'

// Utils
import analytics from 'app/views/utils/analytics'

// Redux
import {
  getQuizById,
  getQuizStep,
  startQuiz,
} from 'app/state/modules/quiz'


class QuizDetail extends React.Component {
  constructor(props) {
    super(props)

    this.handleClickStart = this.handleClickStart.bind(this)
  }

  componentDidMount() {
    analytics.page('quiz-start')

    this.props.getQuizById(this.props.match.params.id)
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.quiz.started_at) {
      if (nextProps.quiz.completed_at !== null) {
        this.props.history.push(`/quiz/${this.props.match.params.id}/results`)
      } else if (nextProps.quiz.questions.length > 0) {
        this.props.history.push(`/quiz/${this.props.match.params.id}/tour`)
      } else {
        this.props.getQuizStep(this.props.match.params.id, nextProps.quiz.questions[0].uuid)
      }
    }
  }

  handleClickStart() {
    this.props.startQuiz(this.props.match.params.id)
  }

  render() {
    return (
      <div>
        <div className="uk-cover-container uk-background-secondary uk-padding-large uk-padding-remove-bottom uk-padding-remove-top uk-light">
          <div className="uk-section uk-text-center">
            <img src="/static/icons/test.png" style={{ height: 100 }} alt="test icon" />
            <h2>Secure Coding IQ Instructions</h2>
            <p>
              The assessment is timed and it must be taken all in one sitting.
            </p>
            <button
              type="button"
              className="uk-button uk-button-primary uk-button-large tm-button-primary tm-button-large uk-margin-right"
              onClick={this.handleClickStart}
            >
              Start the Assessment
            </button>
            <Link to={`/quiz/${this.props.match.params.id}/results`} className="uk-button uk-button-primary uk-button-large tm-button-primary tm-button-large">
              Assess Your Team Now
            </Link>
          </div>
        </div>

        <div className="uk-container">
          <div className="uk-section uk-text-center">
            <h3>Secure Coding IQ Assesment Details</h3>
            <p>
              There is a walk through of the platform, three coding questions, and one multiple
              choice question.
            </p>
            <p>
              You will get to select your preferred programming language .NET, Java, Python, PHP,
              Node.js, and Ruby.
            </p>
            <p>
              Once the assessment is completed you will be able to view your score and your
              organization's score (based on email domain).
            </p>

            <div className="tm-intro-image uk-padding-large uk-padding-remove-bottom">
              <div className="uk-inline">
                <img
                  src="/static/images/device-laptop.png"
                  width="960"
                  height="720"
                  alt="Laptop Device"
                />
                <div
                  style={{
                    position: 'absolute',
                    top: '5%',
                    left: '12%',
                    right: '12%',
                  }}
                >
                  <img src="/static/screenshots/quiz.png" alt="quiz screenshot" />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="uk-cover-container uk-background-muted">
          <div className="uk-container">
            <div className="uk-section uk-margin-medium-bottom uk-padding-large uk-text-center">
              <h3>Start the Assessment</h3>
              <div>
              <button
                type="button"
                className="uk-button uk-button-primary uk-button-large tm-button-primary tm-button-large uk-margin-right"
                onClick={this.handleClickStart}
              >
                Start the Assessment
              </button>
              <Link to={`/quiz/${this.props.match.params.id}/results`} className="uk-button uk-button-primary uk-button-large tm-button-primary tm-button-large">
                Assess Your Team Now
              </Link>
              </div>
            </div>
          </div>
          <div className="uk-cover-container uk-background-secondary uk-padding-large uk-padding-remove-vertical uk-light">
            <div className="uk-container">
              <div className="uk-section uk-text-center uk-padding">
                <p>
                  Learn more about our Secure Development Training for Developers
                </p>
                <Link
                  to="/secure-development-training"
                  className="uk-button uk-button-default uk-button-large"
                >
                  Learn More
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  isAuthenticated: state.auth.authenticationStatus === 'LOGGED_IN',
  quiz: state.quiz.quiz,
})

const mapDispatchToProps = dispatch => ({
  getQuizById: (quizId) => { dispatch(getQuizById(quizId)) },
  getQuizStep: (quizId, questionId) => { dispatch(getQuizStep(quizId, questionId)) },
  startQuiz: (quizId) => { dispatch(startQuiz(quizId)) },
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(QuizDetail))
